import { constants } from "script/constant";

function SidebarHelper({
  user,
  plugins,
  navigation,
  isAIEnabled,
  isBetaAIEnabled,
  userSettings,
  isCreateMatterEnabled,
}) {
  // Helper function to deep copy navigation data
  const deepCopyNavigation = (navData) => {
    if (!navData) return [];
    return navData.map(item => ({
      ...item,
      _children: item._children ? [...item._children.map(child => ({ ...child }))] : undefined
    }));
  };


  const manageAISettings = (navigationData) => {
    const workingData = deepCopyNavigation(navigationData);
    if (!isAIEnabled) {
      return workingData.filter(nav => nav.id !== constants.SIDEBAR_IDS.AISettingID);
    }
    return workingData;
  };
  const manageBetaAISetting = (navigationData) => {
    const workingData = deepCopyNavigation(navigationData);
    if (!isBetaAIEnabled) {
      return workingData.filter(nav => nav.id !== constants.SIDEBAR_IDS.BetaAISettingID);
    }
    return workingData;
  }


  const loadPlugin = navigationData => {
    if (!navigationData) return [];
    const workingData = deepCopyNavigation(navigationData);

    let pluginID = `${process.env.REACT_APP_PLUGIN_ID}`;
    const netDocumentsDatas = plugins?.filter(a => a.pluginID == pluginID);

    if (netDocumentsDatas && netDocumentsDatas.length > 0 && netDocumentsDatas[0]?.isActive === false) {
      return workingData.filter(nav => nav.id !== constants.SIDEBAR_IDS.NetDocument);
    }
    return workingData;
  };
  const loadIManage = navigationData => {
    if (!navigationData) return [];
    const workingData = deepCopyNavigation(navigationData);

    let pluginID = `${process.env.REACT_APP_IMANAGE_PLUGIN_ID}`;
    const imanageDatas = plugins?.filter(a => a.pluginID == pluginID);

    if (imanageDatas && imanageDatas.length > 0 && imanageDatas[0]?.isActive === false) {
      return workingData.filter(nav => nav.id !== constants.SIDEBAR_IDS.IManage);
    }
    return workingData;
  };

  const removingItemsFromMatterData = navigationData => {
    if (!navigationData) return [];
    const workingData = deepCopyNavigation(navigationData);

    // Handle planner enabled setting
    if (userSettings.isPlannerEnabled === false) {
      const matterNav = workingData.find(nav => nav.id === constants.SIDEBAR_IDS.MatterID);
      if (matterNav && matterNav._children) {
        matterNav._children = matterNav._children.filter(item => item.to !== "/matter/task");
      }
    }

    // Handle create matter settings
    if (isCreateMatterEnabled === false || userSettings.canCreateMatter === false) {
      const matterNav = workingData.find(nav => nav.id === constants.SIDEBAR_IDS.MatterID);
      if (matterNav && matterNav._children) {
        matterNav._children = matterNav._children.filter(item => item.to !== "/matter/create-matter");
      }
    }

    if (isBetaAIEnabled === false) {
      const reportNav = workingData.find(nav => nav.id === constants.SIDEBAR_IDS.ReportID);
      if (reportNav && reportNav._children) {
        reportNav._children = reportNav._children.filter(item => item.to !== "/report/ai-history");
      }
    }
    // Handle docketing user settings
    if (!user.isDocketingUser) {
      // Remove audit user from ManageUser
      const manageUserNav = workingData.find(nav => nav.id === constants.SIDEBAR_IDS.ManageUser);
      if (manageUserNav && manageUserNav._children) {
        manageUserNav._children = manageUserNav._children.filter(item => item.to !== "/users/audit-user");
      }

      // Remove events from ManageEvents
      const manageEventsNav = workingData.find(nav => nav.id === constants.SIDEBAR_IDS.ManageEvents);
      if (manageEventsNav && manageEventsNav._children) {
        manageEventsNav._children = manageEventsNav._children.filter(item =>
          item.to !== "/event/find-events" && item.to !== "/event/duplicate-events"
        );
      }
    }

    // Handle reminder report setting - KEY FIX: Only filter if explicitly false
    if (userSettings.canCreateReminder === false) {
      const reportNav = workingData.find(nav => nav.id === constants.SIDEBAR_IDS.ReportID);
      if (reportNav && reportNav._children) {
        reportNav._children = reportNav._children.filter(item => item.to !== "/report/reminder-report");
      }
    }

    return workingData;
  };
  const finalCode = () => {
    // Always start from the original navigation data
    let value = navigation;

    // Apply filters in sequence, each working with a fresh copy
    value = manageAISettings(value);
    value = manageBetaAISetting(value);
    value = loadPlugin(value);
    value = loadIManage(value);
    value = removingItemsFromMatterData(value);

    return value;
  };

  return finalCode();
}
export default SidebarHelper;
